import { UserType } from "src/types/users"

export const redirectPath = (userData: UserType) => {
 // console.log("redirectPath......",)
  if (userData.ref_type === 'Manufacturer' || userData.ref_type === 'fad' ) {
    return "/statistics"
  } else if (userData.ref_type === 'regional_manager') {
    return `/regions/${userData.id}?id=${userData.id}&type=regions&role=regional_manager`
  } else if (userData.ref_type === 'rep') {
    return`/territories/${userData.id}?id=${userData.id}&&role=rep&type=territories`
  } else if (userData.ref_type === 'area_manager') {
    return `/areas/${userData.id}?id=${userData.id}&role=area_manager&type=areas`;
  } else if (userData.ref_type === 'district_manager'  ) {
    return `/district/${userData.id}?id=${userData.id}&role=${userData.ref_type}&type=district`;
  } else {
    return ""
  }
}
